import * as firebase from "firebase"

// var config = {
//     apiKey: "AIzaSyDSr3qNobST34J2HL_ufcwBv-musvaMO8A",
//     authDomain: "vue-testprojcet.firebaseapp.com",
//     databaseURL: "https://vue-testprojcet.firebaseio.com",
//     projectId: "vue-testprojcet"
// }

let config = {
    apiKey: "AIzaSyAoRoxm_zjbIBBPgJOGI8CTOjGFn7-s0Sk",
    authDomain: "hybrid-mobile-3ece1.firebaseapp.com",
    databaseURL: "https://hybrid-mobile-3ece1.firebaseio.com",
    projectId: "hybrid-mobile-3ece1",
    storageBucket: "hybrid-mobile-3ece1.appspot.com",
    messagingSenderId: "45475131267",
}

export default firebase.apps[0] || firebase.initializeApp(config)